(() => {
  const selector = 'input[type="checkbox"][name^="filter."]';

  function enableAllFacets(scope = document) {
    scope.querySelectorAll('input[disabled][name^="filter."]').forEach((input) => {
      input.disabled = false;
    });
    scope.querySelectorAll('.facets__label.disabled, .mobile-facets__label.disabled').forEach((el) => {
      el.classList.remove('disabled');
    });
  }

  // Only one filter active at a time
  document.addEventListener(
    'change',
    (e) => {
      const target = e.target;
      if (!target.matches(selector)) return;

      if (target.checked) {
        document.querySelectorAll(selector).forEach((cb) => {
          if (cb !== target) cb.checked = false;
        });
      }

      // re-enable any newly disabled items after update
      setTimeout(enableAllFacets, 0);
    },
    true
  );

  // run on load + after AJAX re-render
  document.addEventListener('DOMContentLoaded', () => enableAllFacets());
  new MutationObserver(() => enableAllFacets()).observe(document.body, { childList: true, subtree: true });
})();
